var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.337,
    height: 50.511,
    viewBox: "0 0 37.337 50.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assignment",
    transform: "translate(-7.669 -1.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16244",
    "data-name": "Path 16244",
    d: "M93.106,33.942q0,9.754,0,19.509a5.433,5.433,0,0,1-3.755,5.434,5.28,5.28,0,0,1-1.613.267c-8.851.016-17.7.032-26.555,0A5.362,5.362,0,0,1,55.866,54.6a6.925,6.925,0,0,1-.076-1.231c0-12.971.021-25.943-.021-38.914a5.6,5.6,0,0,1,4.594-5.723,4.787,4.787,0,0,1,.767-.063c8.869,0,17.738-.023,26.606.008a5.355,5.355,0,0,1,5.293,4.575,7.836,7.836,0,0,1,.072,1.334q.006,9.678,0,19.354Zm-2.188-.008V14.478a3.312,3.312,0,0,0-3.6-3.627H61.586a3.315,3.315,0,0,0-3.612,3.615V53.379a3.317,3.317,0,0,0,3.626,3.6H87.279a3.322,3.322,0,0,0,3.638-3.643Z",
    transform: "translate(-48.101 -7.47)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16246",
    "data-name": "Path 16246",
    d: "M128,212.725a4.374,4.374,0,0,1-8.464,1.525.615.615,0,0,0-.7-.472q-6.716.021-13.432.007a3.25,3.25,0,0,1-.714-.058,1.081,1.081,0,0,1,.036-2.107,3.245,3.245,0,0,1,.664-.047q6.691,0,13.381,0c.4,0,.617-.065.781-.5A4.372,4.372,0,0,1,128,212.723Zm-6.551-.062a2.133,2.133,0,0,0,2.155,2.2,2.182,2.182,0,1,0,.034-4.364A2.137,2.137,0,0,0,121.447,212.664Z",
    transform: "translate(-89.587 -179.645)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16247",
    "data-name": "Path 16247",
    d: "M149.232,80.857c2.644-2.633,5.185-5.162,7.727-7.691a5.437,5.437,0,0,1,.447-.426,1.074,1.074,0,0,1,1.451.066,1.1,1.1,0,0,1,.1,1.453,3.607,3.607,0,0,1-.349.377l-8.26,8.263c-.777.777-1.3.771-2.089-.017-1.323-1.321-2.659-2.631-3.953-3.979a1.855,1.855,0,0,1-.459-1.026.908.908,0,0,1,.693-.92,1.113,1.113,0,0,1,1.222.309c.942.95,1.892,1.893,2.831,2.846.228.231.426.491.642.743Z",
    transform: "translate(-124.06 -62.522)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16248",
    "data-name": "Path 16248",
    d: "M110.344,296.213c1.785,0,3.568-.008,5.353,0a1.093,1.093,0,1,1,.014,2.181c-.978.01-1.955,0-2.934,0-2.591,0-5.181.012-7.772-.015a1.781,1.781,0,0,1-.974-.347.934.934,0,0,1-.237-1.132.976.976,0,0,1,.939-.682c.824-.015,1.647-.011,2.47-.012q1.57,0,3.139,0Z",
    transform: "translate(-89.446 -255.479)",
    fill: "#0098da"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.4d35194e16372e3e8b9d3704e7e5d10f.svg";
export { ForwardRef as ReactComponent };